<template>
    <div class="box">
        <div class="columns is-vcentered">
            <div class="column">
                <img :src="'img/' + product + '/1.svg'">
                <b-button type="is-primary" expanded size="is-medium" tag="a" :href="'/' + product">Learn More</b-button>
            </div>
            <div class="column">
                <img :src="'img/' + product + '/2.svg'">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductView",
        props: ['product']
    }
</script>

<style scoped>
    img {
        display: block;
        width: 540px;
        margin-bottom: 36px;
    }

    .box {
        margin-bottom: 42px;
    }
</style>